<template>
  <div class="flex flex-col gap-6 lg:flex-row lg:justify-between">
    <div
      v-if="hasSummary"
      class="min-w-0 px-4 text-center lg:px-0"
      :class="{ 'order-last lg:order-first': showBreadcrumbs }"
      data-testid="ctSearchSummary"
    >
      <p
        v-if="description"
        class="text-left"
      >
        {{ description }}
      </p>
      <CategoryBreadcrumbs v-if="showBreadcrumbs" />
      <p
        v-if="searchResultCount !== undefined"
        data-testid="ctSearchResultCount"
      >
        <span>{{ $t('Number of Search Results', searchResultCount, { count: searchResultCount }) }}</span>
        <span
          v-if="searchTerm"
          class="font-bold"
        >
          {{ $t('Search Term:') }} {{ searchTerm }}
        </span>
      </p>
    </div>
    <div class="flex items-center justify-end leading-7 px-4 lg:px-0 lg:ml-auto">
      <div class="w-1/2 pr-2.5 lg:hidden">
        <button
          type="button"
          class="w-full border rounded-[var(--buttons-border-radius)] py-[0.3rem] font-semibold text-EXPONDO-primary-80"
          data-testid="ctFilterButton"
          @click="toggleFilterModal"
        >
          {{ $t('Filter') }} ({{ activeFilterCount }})
        </button>
      </div>
      <div
        class="flex w-1/2 lg:w-auto"
        data-testid="sortingSelect"
      >
        <span class="hidden lg:inline self-center whitespace-nowrap">
          {{ $t('Sort by') }}:
        </span>
        <div class="relative pl-2.5 w-full">
          <select
            class="w-full py-1 pl-1 pr-10 border border-EXPONDO-grey-20 rounded bg-EXPONDO-white text-EXPONDO-grey
              appearance-none cursor-pointer [text-align-last:center]"
            :value="sortBy"
            :aria-label="$t('Sort by')"
            @change="$emit('sort', ($event.target as HTMLSelectElement).value)"
          >
            <option
              v-for="method in SORTING_METHODS"
              :key="method.value"
              :value="method.value"
            >
              {{ $t(method.label) }}
            </option>
          </select>
          <span
            class="absolute inset-y-px right-px w-10 flex items-center justify-center rounded-r bg-EXPONDO-grey-5
              pointer-events-none"
          >
            <span class="iconify svg--carrot-down w-4 h-4 text-EXPONDO-grey" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SORTING_METHODS } from '~~/constants/typesense';

// CT version of SearchResultsTop. `searchResultCount` is for /search, `showBreadcrumbs` for category pages.
defineOptions({ name: 'CtSearchResultsTop' });

const props = withDefaults(defineProps<{
  sortBy: string;
  activeFilterCount: number;
  showBreadcrumbs?: boolean;
  searchResultCount?: number;
  searchTerm?: string;
  description?: string;
}>(), {
  showBreadcrumbs: false,
  searchResultCount: undefined,
  searchTerm: '',
  description: '',
});

defineEmits<{
  (event: 'sort', value: string): void;
}>();

const { toggleFilterModal } = useUiState();

const hasSummary = computed(() =>
  Boolean(props.description) || props.showBreadcrumbs || props.searchResultCount !== undefined);
</script>
